import { sharedFeedbackValue, isSharedRemoteFeedback, sharedFeedbackText, type SharedRemoteFeedback } from "./sharedFeedbackPresentation";
import { getI18n } from "react-i18next";
import source from "./locales/en/transferFeedback";
export type TransferRemoteFeedback = SharedRemoteFeedback | { remote: true; fallback: string; descriptor: { code: keyof typeof source; params: Record<string, string | number> } };
const own = (value: object, key: string) => Object.prototype.hasOwnProperty.call(value, key);
export function transferRemoteValue(fallback: string, descriptor: unknown): string | TransferRemoteFeedback {
 const shared = sharedFeedbackValue(fallback, descriptor);
 if (shared) return shared;
 if (!descriptor || typeof descriptor !== "object" || Array.isArray(descriptor)) return fallback;
 const d=descriptor as Record<string,unknown>;
 if (Object.keys(d).some(k=>k!=="code"&&k!=="params") || !own(d,"code") || !own(d,"params") || typeof d.code !== "string" || !own(source,d.code) || !d.params || typeof d.params !== "object" || Array.isArray(d.params)) return fallback;
 const code=d.code as keyof typeof source;
 const expected=[...new Set([...source[code].matchAll(/{{(\w+)}}/g)].map(m=>m[1]!))].sort();
 if(JSON.stringify(Object.keys(d.params).sort())!==JSON.stringify(expected))return fallback;
 const params: Record<string,string|number>={};
 for(const [key,value] of Object.entries(d.params)) {
  if(typeof value === "string" ? value.length > 4096 : typeof value !== "number" || !Number.isFinite(value)) return fallback;
  params[key]=value;
 }
 return {remote:true,fallback,descriptor:{code,params}};
}
export function transferRemote(response: unknown, field: "message" | "warning" = "message"): string | TransferRemoteFeedback | undefined {
 if(!response || typeof response!=="object" || Array.isArray(response)) return undefined;
 const r=response as Record<string,unknown>;
 if(!own(r,field) || typeof r[field]!=="string" || !r[field])return undefined;
 return transferRemoteValue(r[field],own(r,field+"Presentation")?r[field+"Presentation"]:undefined);
}
export function transferRemoteText(feedback: TransferRemoteFeedback): string {
 if (isSharedRemoteFeedback(feedback)) return sharedFeedbackText(feedback);
 const checked=transferRemoteValue(feedback.fallback,feedback.descriptor);
 if(typeof checked==="string")return checked;
 if (isSharedRemoteFeedback(checked)) return sharedFeedbackText(checked);
 const engine=getI18n(),{code,params}=checked.descriptor;
 const template=engine?.isInitialized ? (engine as unknown as { t: (key: string, options: Record<string, unknown>) => string }).t(code,{ns:"transferFeedback",keySeparator:false,interpolation:{skipOnVariables:true}}) : source[code];
 if(template===code)return checked.fallback;
 return template.replace(/{{\s*(\w+)\s*}}/g,(_all,key:string)=>String(params[key]??""));
}
